import React from 'react';
import ReactDOM from 'react-dom';
import configureStore from './redux/store';
import AppContainer from 'react-hot-loader/lib/AppContainer';
import Root from './Root';
import '../../tools/knotty';
import AbacusClientUtils from '@homeaway/abacus-client-utils';

// Polyfills
import 'whatwg-fetch';

/**
 * Main client-side entry point. This is not used during
 * server-side rendering, only after the javascript bundle
 * has been loaded into the browser.
 */

function initReactApp() {
  // Initial state as set by the server-side render
  const initialState = window.__INITIAL_STATE__;

  const store = configureStore(initialState);

  AbacusClientUtils.initialize(store.getState().abacus.experiments);

  ReactDOM.hydrate(
    <AppContainer store={store}>
      <Root store={store}/>
    </AppContainer>,
    document.getElementById('root')
  );

  // Hot module replacement in development env only
  if (module.hot) {
    module.hot.accept('./Root', () => {
      const RootRequired = require('./Root').default;
      ReactDOM.unmountComponentAtNode(document.getElementById('root'));
      ReactDOM.hydrate(
        <AppContainer store={store}>
          <RootRequired store={store} />
        </AppContainer>,
        document.getElementById('root')
      );
      console.log(`[HMR] Rendered at ${new Date().toLocaleTimeString()}`); // eslint-disable-line
    });
  }
}

function startApp() {
  if (document.readyState !== 'loading') {
    initReactApp();
  } else {
    document.addEventListener('DOMContentLoaded', initReactApp);
  }
}

startApp();



// WEBPACK FOOTER //
// ./src/universal/index.js